import React from 'react'
import { MeetingDur } from '../../types/availability'

interface ChannelTogglesProps {
  callEnabled: boolean
  videoEnabled: boolean
  defaultDur: MeetingDur
  onCallToggle: (enabled: boolean) => void
  onVideoToggle: (enabled: boolean) => void
  onDurationChange: (duration: MeetingDur) => void
  className?: string
}

export default function ChannelToggles({
  callEnabled,
  videoEnabled,
  defaultDur,
  onCallToggle,
  onVideoToggle,
  onDurationChange,
  className = ''
}: ChannelTogglesProps) {
  return (
    <div className={`space-y-4 ${className}`}>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">
          📞 Kanalen & Standaardduur
        </label>
        
        <div className="space-y-3">
          {/* Call Toggle */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <span className="text-lg">📞</span>
              <span className="text-sm font-medium">Telefoongesprekken</span>
            </div>
            <button
              onClick={() => onCallToggle(!callEnabled)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                callEnabled ? 'bg-blue-600' : 'bg-gray-200'
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  callEnabled ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>

          {/* Video Toggle */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <span className="text-lg">🎥</span>
              <span className="text-sm font-medium">Beeldbellen</span>
            </div>
            <button
              onClick={() => onVideoToggle(!videoEnabled)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                videoEnabled ? 'bg-blue-600' : 'bg-gray-200'
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  videoEnabled ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>
        </div>
      </div>

      {/* Default Duration */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          ⏱️ Standaardduur gesprek
        </label>
        <select
          value={defaultDur}
          onChange={(e) => onDurationChange(Number(e.target.value) as MeetingDur)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value={15}>15 minuten</option>
          <option value={30}>30 minuten</option>
          <option value={45}>45 minuten</option>
        </select>
      </div>

      {/* Info */}
      {!callEnabled && !videoEnabled && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
          <p className="text-sm text-yellow-800">
            💡 Je hebt beide kanalen uitgeschakeld. Leden kunnen je alleen via chat bereiken.
          </p>
        </div>
      )}
    </div>
  )
}
